import React, { useState } from 'react'
import { View, Text, ScrollView } from 'react-native'
import { useDispatch } from 'react-redux'
import tw from 'tailwind-rn'
import { StackNavigationProp } from '@react-navigation/stack'

import ActionCreators from '../../store/actions'
import { HGView, HGText, HGGroup, HGButton } from '../../components/HGUI'
import ModalSignIn from '../../components/HGModal/ModalSignIn'
import ChangeEmailForm, { ChangeEmailValues } from './ChangeEmailForm'
import { RootStackParamList } from '../../navigators/AppNavigator'

type Props = {
  navigation: StackNavigationProp<RootStackParamList>
}

const UserChangeEmailScreen = (props: Props) => {
  const { navigation } = props
  const [modalSignInVisible, setModalSignInVisible] = useState(false)
  const [formSuccess, setFormSuccess] = useState(false)
  const dispatch = useDispatch()

  const performUserEmailChange = (
    values: ChangeEmailValues,
    setSubmitting: (value: boolean) => void
  ) => {
    const { username: email } = values

    setModalSignInVisible(false)
    setSubmitting(true)

    dispatch(ActionCreators.changeUserEmail({ newEmail: email }))
      .then(() => {
        setFormSuccess(true)
      })
      .catch((reason) => {
        if (reason.code && reason.code === 'auth/requires-recent-login') {
          setModalSignInVisible(true)
        } else {
          return dispatch(
            ActionCreators.handleError({ code: 'change-email/error' })
          )
        }
      })
      .then(() => {
        setSubmitting(false)
      })
  }

  return (
    <>
      <ModalSignIn
        visible={modalSignInVisible}
        onAbort={() => setModalSignInVisible(false)}
        onSuccess={performUserEmailChange}
      />
      <ScrollView>
        <HGView>
          <View style={tw('px-3')}>
            <HGGroup style={tw('mt-6')}>
              {!formSuccess && (
                <View>
                  <ChangeEmailForm onSubmit={performUserEmailChange} />
                </View>
              )}

              {formSuccess && (
                <>
                  <View style={tw('flex items-center mb-3')}>
                    <Text style={tw('text-2xl')}>📪</Text>
                  </View>
                  <HGText style={{ textAlign: 'center' }}>
                    Ihr E-Mail-Adresse wurde erfolgreich geändert.
                  </HGText>

                  <View style={tw('mt-6')} />
                  <HGButton
                    title="Zurück zum Profil"
                    onPress={() => navigation.popToTop()}
                  />
                </>
              )}
            </HGGroup>
          </View>
        </HGView>
      </ScrollView>
    </>
  )
}

export default UserChangeEmailScreen
